import Layout from "../components/Layout";
import RequireAuth from "../components/RequireAuth";
import ErrorPage from "../pages/ErrorPage";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Register from "../pages/Register";
import RegisterThankYou from "../pages/Register/ThankYou";
import User from "../pages/User";
import Course from "../pages/Course";
import Lesson from "../pages/Lesson";
import Topic from "../pages/Topic";
import CookiePolicy from "../pages/CookiePolicy";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import HelpInfo from "../pages/HelpInfo";
import ChangePassword from "../pages/ChangePassword";
import {userLoader, coursesLoader, courseLoader, lessonLoader, topicLoader, authenticationLoader} from "../data/loaders";
import {Navigate} from "react-router-dom";

const routes = [
  {
    path: '/',
    element: (
      <RequireAuth>
        <Layout/>
      </RequireAuth>
    ),
    errorElement: <ErrorPage />,
    loader: authenticationLoader,
    children:
      [
        {
          path: '/',
          element: <Home/>,
          loader: coursesLoader,
        },
        {
          path: '/corsi/:courseId',
          element: <Course/>,
          id: "course_page",
          loader: courseLoader,
          children: [
            {
              path: '/corsi/:courseId/lezioni/:lessonId',
              element: <Lesson/>,
              id: "lesson_page",
              loader: lessonLoader,
              children: [
                {
                  path: '/corsi/:courseId/lezioni/:lessonId/approfondimenti/:topicId',
                  element: <Topic/>,
                  id: "topic_page",
                  loader: topicLoader,
                },
              ]
            },
          ]
        },
        {
          path: '/utente/cambia-password',
          element: <ChangePassword/>,
        },
        {
          path: '/utente',
          element: <User/>,
          loader: userLoader,
        },
        // {
        //   path: '/cookie-policy',
        //   element: <CookiePolicy/>,
        // },
        {
          path: '*',
          element: <Navigate to="/" />,
        },
      ],
  },
  {
    path: '/login',
    element: <Login/>,
  },
  {
    path: '/registrazione/grazie',
    element: <RegisterThankYou/>,
  },
  {
    path: '/registrazione',
    element: <Register/>,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicy/>,
  },
  {
    path: '/privacy-policy-form-contatto',
    element: <PrivacyPolicy/>,
  },
  {
    path: '/assistenza',
    element: <HelpInfo/>,
  },
];

export default routes;